module.exports = __webpack_public_path__ + "img/text_present_list.385e5c6b.png";